import { initSubRoutes } from '../../../../utils/router';

const RoutesModifierEmploye = initSubRoutes({
    route: '/employes/:id/modifier',
    subroutes: {},
    nom: 'Modifier employé',
});

export default RoutesModifierEmploye;
